import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

const CoffeehouseLogo = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 100 100">
        {/* Background */}
        <rect x="0" y="0" width="100" height="100" fill="white" rx="8" />
        {/* Steam */}
        <path d="M30 18 Q27 11 30 4" fill="none" stroke="#9E9E9E" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M50 16 Q47 9 50 2" fill="none" stroke="#9E9E9E" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M70 18 Q67 11 70 4" fill="none" stroke="#9E9E9E" strokeWidth="2.5" strokeLinecap="round" />
        {/* Cup body */}
        <path d="M12,26 L88,26 L78,72 L22,72 Z" fill="#6F4E37" />
        {/* Cup rim highlight */}
        <rect x="10" y="22" width="80" height="6" rx="3" fill="#8B6347" />
        {/* Handle */}
        <path
            d="M78,38 Q100,38 100,52 Q100,66 78,66"
            fill="none"
            stroke="#6F4E37"
            strokeWidth="7"
            strokeLinecap="round"
        />
        {/* Saucer */}
        <ellipse cx="50" cy="75" rx="42" ry="7" fill="#8B6347" />
        {/* Saucer base line */}
        <ellipse cx="50" cy="82" rx="30" ry="4" fill="#6F4E37" />
    </SvgIcon>
);

export default CoffeehouseLogo;
